import React from 'react'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet-async'
import { injectIntl } from 'react-intl'
import FormattedMessage from '../../components/FormattedMessage/FormattedMessage'
import ForgotPasswordForm from '../../components/Form/ForgotPasswordForm/ForgotPasswordForm'
import { userActions } from '../../redux/actions'

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
    }
  }

  onPasswordResetRequest = values => this.props.passwordResetRequest({ email: values.email })

  render() {
    const label = this.props.intl.formatMessage({ id: 'page.forgotPasswordPage.title.heroTitle' })
    return (
      <div className="forgot-password-page" aria-labelledby="forgot-password-page-title">
        <Helmet>
          <title>{label}</title>
          <meta name="description" content="your description" />
        </Helmet>
        <div className="container mt-5 mb-5">
          <h1 className="page-title" id="forgot-password-page-title">
            <FormattedMessage id="page.forgotPasswordPage.title.heroTitle" />
          </h1>
          <p>
            <FormattedMessage id="page.forgotPasswordPage.title.description" />
          </p>
          <small>
            <p>
              <FormattedMessage id="page.forgotPasswordPage.title.note" />
            </p>
          </small>
          <div className="row justify-content-center">
            <div className="col-md-8 col-xl-6">
              <ForgotPasswordForm onSubmit={this.onPasswordResetRequest} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  passwordResetRequest: (...args) => dispatch(userActions.passwordResetRequest(...args)),
})

export default injectIntl(connect(null, mapDispatchToProps)(ForgotPassword))
